import { isObject } from 'lodash';
export function setupReLoginInterceptor(axiosInstance) {
    if (window.location.protocol !== 'https:')
        return;
    axiosInstance.interceptors.request.use((config) => {
        // eslint-disable-next-line no-param-reassign
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        return config;
    });
    axiosInstance.interceptors.response.use(undefined, (error) => {
        if (!isObject(error)) {
            return Promise.reject(error);
        }
        const { response } = error;
        if (!response)
            Promise.reject(error);
        if (response.status === 401) {
            window.xy_runtime_utils?.reLogin?.();
        }
        Promise.reject(error);
    });
}
